import Vue from 'vue';
import ElementUI from 'element-ui';
import viserVue from 'viser-vue';
import './assets/css/element-theme/index.css';
import './assets/css/global.styl';
import App from './App.vue';
import router from './router';
import store from './store';
// import echarts from 'echarts'
import './filters/index';
import request from './utils/request';
import { toYuan, fenToWan, toFen, toRate, toKYuan } from './utils/unit-conversion';
import { initSign } from '@didi/wsgsig';
// 避免验签业务调试开发
sessionStorage.setItem('debugger', 'x');
// 接入签名SDK(https://cooper.didichuxing.com/docs/document/2200553116152)
initSign({
    bizId: '3b0100090b304412f31ed831b156c938',
    appVer: 'V1.0',
    os: '4',
});
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(viserVue);
Vue.prototype.$request = request;
Vue.prototype.$omega = window.Omega;
Vue.prototype.$utils = {
    toYuan: function (amount) {
        return toYuan(amount).toFixed(2);
    },
    fenToWan: function (amount) {
        return fenToWan(amount).toFixed(2);
    },
    toFen: function (amount) {
        return toFen(amount);
    },
    toRate: function (amount) {
        return toRate(amount).toFixed(2);
    },
    toCompareYuan: function (amount) {
        var re = /\./;
        return re.test(toYuan(amount)) ? toYuan(amount).toFixed(2) : toYuan(amount);
    },
    toKYuan: function (amount) {
        return toKYuan(amount);
    },
};
var initialData = window.__INITIAL_STATE__;
try {
    initialData = initialData || {};
    store.commit('user/update', initialData);
}
catch (err) {
    console.log(err);
}
/* eslint-disable no-new */
;
(function () {
    return new Vue({
        el: '#app',
        router: router,
        store: store,
        components: { App: App },
        template: '<App/>',
    });
})();
